module.exports = __webpack_public_path__ + "img/coming-soon.6d36b50e.png";